<template>
  <element>
    <AppBar :title="title" />
    <v-container class="pt-0 pl-0 pr-0">
      <v-row no-gutters class="d-flex justify-content-center">
        <v-icon class="page-icon pb-1 ml-2" color="#2e384d" size=64>mdi-print</v-icon>
      </v-row>

      <v-row no-gutters class="px-3 mt-4">
        <v-btn
          class="submit-btn"
          height="45px"
          color="#033e8c"
          depressed
          block
          dark
          @click="printDocument"
          >
          {{ title }}
        </v-btn>
        </v-row>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue"
import { DOCUMENT_TYPE_PART_STICKER } from "@/constants"

import printJS from 'print-js'

export default {
  name: "PrintPartStickerPage",
  props: {},
  components: {
    AppBar,
  },
  data() {
    return {
      title: '',
      partId: null,
      documentType: DOCUMENT_TYPE_PART_STICKER,
      documentContent: null,
      latestDocuemntId:-1,
    }
  },
  methods: {
    printDocument(){
        if(this.documentContent) {
            printJS ({
                        printable: this.documentContent, 
                        type: 'pdf', 
                        base64: true, 
                        onPrintDialogClose: this.complete
                    })
        }
    },
    getLatestDocumentId(v, i)
    {
        console.log('getLatestDocumentId called: ',i)
        if (i>this.latestDocuemntId)
            this.latestDocuemntId = i
    },
    complete() {
      const taskId = this.$store.getters.getCurrentTask?.id

      if (taskId) {
        this.$store.dispatch('completeTask', { taskId })
        .then(response => {
          console.log("Task completed successfully!", taskId, response)
        })
        .catch(error => {
          console.log("Failed completing task!", taskId, error)
        })
        .finally(() => {
          this.isUploading = false
        })
      } else {
        this.isUploading = false
      }
    }
  },
  created() {
    this.title = this.$store.getters.getCurrentTask.taskName
    const pid = this.$store.getters.getCurrentPID
    // we retrieve process variables
    this.$store.dispatch('retrieveProcessVariables', pid)
    .then(response => {
      try {
        this.partId = parseInt(response.data.data.part_id.value)
        console.log(this.partId)
        //--
        // we retrieve the most up to date part sticker for the part
        this.axios.get(`/Documents/get?data_id=${this.partId}&document_type_id=${DOCUMENT_TYPE_PART_STICKER}`, {}, { withCredentials: true })
        .then(response => {
            // td 202009180048 PrintJS expects "pure" base64 content without the prefix, so we strip it (not good, performance-wise)
            // we need to remove the following "data:application/pdf;base64,", let's assume this string is always applied this way for our PDFs
            response.data.data.forEach(this.getLatestDocumentId);
            this.documentContent=response.data.data[this.latestDocuemntId]['data_doc_raw'].slice("data:application/pdf;base64,".length)
        })
        .catch(error => {
        console.log("Failed retrieving Part sticker", error)
        })

      } catch (error) {
        console.log("Failed retrieving variables from API.", error)
      }
    })
    .catch(error => {
      console.log("Failed retrieving variables from API", error)
    })

    
  }
}
</script>

<style scoped>
</style>